import HitItem from '../HitItem'
import { Stack, Text } from '@mantine/core'
import React from 'react'
import { useTheme } from '../../../components/ThemeProvider'

interface OnlineLendingOutOfConnectionFraudProps {
  data: any
}

export default function OnlineLendingOutOfConnectionFraud({ data }: OnlineLendingOutOfConnectionFraudProps) {
  const theme = useTheme()

  return (
    <div className="mt-2">
      <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
        网贷失联欺诈
      </Text>
      <Stack gap="sm" className="mt-3">
        <HitItem
          name={'网络小贷'}
          hitCount={data?.als_wlxdqzsl_count || 0}
          recentHitTime={data?.als_wlxdqzsl_count === 0 ? '-' : `近${(data?.als_wlxdqzsl_duration ?? 0) + 1}年内`}
        />
        <HitItem
          name={'地方小贷'}
          hitCount={data?.als_dfxdqxsl_count || 0}
          recentHitTime={data?.als_dfxdqxsl_count === 0 ? '-' : `近${(data?.als_dfxdqxsl_duration ?? 0) + 1}年内`}
        />
        <HitItem
          name={'消费金融公司'}
          hitCount={data?.als_xfjrgsqzsl_count || 0}
          recentHitTime={data?.als_xfjrgsqzsl_count === 0 ? '-' : `近${(data?.als_xfjrgsqzsl_duration ?? 0) + 1}年内`}
        />
        <HitItem
          name={'融资租赁公司'}
          hitCount={data?.als_rzzlgsqzsl_count || 0}
          recentHitTime={data?.als_rzzlgsqzsl_count === 0 ? '-' : `近${(data?.als_rzzlgsqzsl_duration ?? 0) + 1}年内`}
        />
        <HitItem
          name={'汽车金融公司'}
          hitCount={data?.als_qcjrgsqzsl_count || 0}
          recentHitTime={data?.als_qcjrgsqzsl_count === 0 ? '-' : `近${(data?.als_qcjrgsqzsl_duration ?? 0) + 1}年内`}
        />
        <HitItem
          name={'其他金融公司'}
          hitCount={data?.als_qtjrgsqzsl_count || 0}
          recentHitTime={data?.als_qtjrgsqzsl_count === 0 ? '-' : `近${(data?.als_qtjrgsqzsl_duration ?? 0) + 1}年内`}
        />
      </Stack>
    </div>
  )
}
